import React from "react";
import PropTypes from "prop-types";
import { drawTube, getScale } from "./SolutionTube.utils";

export function SolutionTube(props) {
  const setStyle = () => getScale(props.size);

  const onClick = () => props.toggleOpen(!props.isOpen);

  return (
    <div
      className="solutiontTube"
      dir="ltr"
      style={setStyle()}
      onClick={onClick}
      role="button"
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClick;
        }
      }}
    >
      {drawTube({
        ...props.solution,
        isOpen: props.isOpen,
        title: props.title,
        id: props.id,
      })}
    </div>
  );
}

SolutionTube.propTypes = {
  /**
   * boolean to set if tube is open
   */
  isOpen: PropTypes.bool,
  /**
   * To set the size of tube
   */
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  /**
   * Info on the solution inside the tube
   */
  solution: PropTypes.shape({
    /**
     * Color of solution
     */
    solutionColor: PropTypes.string,
    /**
     * Hex color value for pellet
     */
    pelletColor: PropTypes.string,
    /**
     * Hex color value for circle label
     */
    circleColor: PropTypes.string,
    /**
     * Label for Tube
     */
    label: PropTypes.string,
    /**
     * Hex color value for banner on which to display Label
     */
    bannerColor: PropTypes.string,
    /**
     * Hex color value to circleColor outline
     */
    circleOutline: PropTypes.string,
  }),
  /**
   * funtion to open/close Tube
   */
  toggleOpen: PropTypes.func,
};

SolutionTube.defaultProps = {
  size: "lg",
};
